import { render, staticRenderFns } from "./SocialLoginBtns.vue?vue&type=template&id=2d1e1d0c&"
import script from "./SocialLoginBtns.vue?vue&type=script&lang=js&"
export * from "./SocialLoginBtns.vue?vue&type=script&lang=js&"
import style0 from "./SocialLoginBtns.vue?vue&type=style&index=0&id=2d1e1d0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GoogleView: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/GoogleView.vue').default,FacebookButton: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/FacebookButton.vue').default})
